<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>
<script>
export default {
  name: "app",
  watch: {
    $route() {
      // if (window._czc) {
      //   var location = window.location;
      //   var content_url = location.pathname + location.hash;
      //   var referer_url = "/";
      //   window._czc.push(["_trackPageview", content_url, referer_url]);
      // }
      this.$uweb.ready().then(() => {
          var location = window.location;
          var content_url = location.pathname + location.hash;
          var referer_url = "/";
          this.$uweb.trackPageview(content_url, referer_url);
        })
        .catch(() => {});
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/App.vue